<template>
    <div class="template-generator-content">
        <div v-if="!hasDefaultSlot" class="empty-content-placeholder">
            <span v-if="editing">Belge İçeriği</span>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props:{
        name:{
            type:String,
            default:""
        },
        editing:Boolean,
    },
    computed:{
        hasDefaultSlot(){
            return !!this.$slots.default
        }
    }
}
</script>

<style>
.template-generator-content{
    height: 100%;
    width: 100%;
}
.template-generator-content .empty-content-placeholder{
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: bold;
}
</style>